import React, { useMemo, useState } from 'react';
import Button from '@mui/material/Button';

import SelectInput from './SelectInput';
import CurrencyInput, { isValidCurrency } from './CurrencyInput';
import TextInput, { isValidText } from './TextInput';
import { Account, CostCenterItem, ProjectWithArticles } from './Types';
import { apiCreateArticle } from './Api';
import { addToCallChain } from './CallCenter';

const accountValueGetter = (account: Account) => account.account_number
const accountNameGetter = (account: Account) => account.account_name

function ArticleCreationDialog({project, officialIncomeAccounts, onCreate, onCancel}: {
  project: ProjectWithArticles,
  officialIncomeAccounts: Account[],
  onCreate: ({newArticleId, newCostCenterItems}: {newArticleId: string, newCostCenterItems: CostCenterItem<ProjectWithArticles>[]}) => void,
  onCancel: () => void
}) {
  const [articleName, setArticleName] = useState('')
  const [standardPrice, setStandardPrice] = useState<number | null>(null)
  const [account, setAccount] = useState<number | null>(null)

  // The income accounts valid for this project, resolved to {number, name}.
  const accountOptions = useMemo<Account[]>(
    () => officialIncomeAccounts.filter(a => project.income_account_numbers.includes(a.account_number)),
    [officialIncomeAccounts, project.income_account_numbers]
  )

  function createArticle() {
    if (standardPrice === null || account === null) return
    let data = {
      'name': articleName,
      'standard_price': standardPrice,
      'income_account': account,
      'project_id': project.project_id,
      'project_number': project.ProjectNumber
    }
    addToCallChain(
      async () => {
        const responseData = await apiCreateArticle(data)
        onCreate({newArticleId: responseData.new_article_id, newCostCenterItems: responseData.cost_center_items})
      },
      true
    )
  }
  
  const isValid = isValidText(articleName) && isValidCurrency(standardPrice) && account !== null

  return (
    <>
    <div id="overlay"></div>
    <div id="popup">
      <h2>Ny artikel</h2>
      <div id="div-popup-inputs">
        <TextInput label="Artikelnamn" inputProps={{'maxLength': "50"}} value={articleName} onChange={setArticleName}/>
        <CurrencyInput label='Standardpris' value={standardPrice} onChange={setStandardPrice}/>
        <SelectInput options={accountOptions} valueGetter={accountValueGetter} nameGetter={accountNameGetter} label='Konto' required={true} value={account} onChange={setAccount}/>
      </div>
      <div className="buttons">
          <Button variant="contained" disabled={!isValid} onClick={createArticle}>Skapa artikel</Button>
          <Button variant="text" onClick={onCancel}>Avbryt</Button>
      </div>
    </div>
    </>

  )
}

export default ArticleCreationDialog
